import React from 'react';

const CardWithBackground = ({
  heading,
  headingIcon,
  subHeading,
  children,
  backgroundImage,
  linkSectionTitle,
  linkIcon,
  links = [],
}) => {
  const containerStyle = {
    position: 'relative',
    padding: '2rem',
    color: '#fff',
    backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    border: '2px',
    borderStyle: 'solid',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: '2rem',
    flexWrap: 'wrap',
  };

  const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    zIndex: 0,
  };

  const leftContentStyle = {
    flex: '2 1 60%',
    position: 'relative',
    zIndex: 1,
    textAlign: 'left',
  };

  const rightLinksStyle = {
    flex: '1 1 30%',
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    textAlign: 'left',
    gap: '1rem',
    marginTop: '5rem',
  };

  const linkStyle = {
    color: '#ffffff',
    textDecoration: 'none',
    fontWeight: 'bold',
    display: 'inline-block',
    width: 'fit-content',
    textAlign: 'left', 
  };

  return (
    <div style={containerStyle}>
      {backgroundImage && <div style={overlayStyle} />}
      
      <div style={leftContentStyle}>
        <h2 style={{ marginBottom: '1rem', lineHeight: '1.4' }}>
          <span style={{
            float: 'left',
            marginRight: '0.5rem',
            display: 'inline-block',
          }}>
            {headingIcon}
          </span>
          {heading}
        </h2>
        <h4> {subHeading && subHeading}</h4>
        <div>{children}</div>
      </div>

      <div style={rightLinksStyle}>
        {linkSectionTitle && <h3 style={{ marginBottom: '0.5rem' }}>{linkSectionTitle}</h3>}
        {links.map(({ label, href }) => (
          <a key={href} href={href} style={linkStyle}>
            {label} {linkIcon}
          </a>
        ))}
      </div>
    </div>
  );
};

export default CardWithBackground;
